/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Weak link to other entity (from Cushla or 3rd party) that has triggered creation of this program.
 * @export
 * @enum {string}
 */

export enum PhysitrackExerciseProgramSourceDto {
  PREGNANCY_JOURNEY = 'CUSHLA_PREGNANCY_JOURNEY',
  HERNIA_JOURNEY = 'CUSHLA_HERNIA_JOURNEY',
}
